// const realUrl = 'https://www.hongxing799.com';
const getFileUrl = str => {
  // const res = findPos(str, '/', 2);
  // return `${realUrl}${str.substring(res)}`;
  return str;
};
// const findPos = (str, cha, num) => {
//   let x = str.indexOf(cha);
//   for (let i = 0; i < num; i++) {
//     x = str.indexOf(cha, x + 1);
//   }
//   return x;
// };
export default getFileUrl;
